import {useAppDispatch, useAppSelector} from "../../../redux/hooks";
import React, {useEffect, useRef, useState} from "react";
import {useSearchParams} from "react-router-dom";
import {Toast} from "primereact/toast";
import {checkPermissions} from "../../../redux/permissions/permissionsUtils";
import {RoleDataSort} from "../../../types/types";
import {getItem} from "../../../redux/cache/cacheService";
import {codes} from "../../../redux/notificationCodes";
import {ProgressBar} from "primereact/progressbar";
import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import {classNames} from "primereact/utils";
import {Column} from "primereact/column";
import {Dialog} from "primereact/dialog";
import {ConfirmDialog} from "primereact/confirmdialog";
import RolesListNav from "./RolesListNav";
import {archiveRole, copyRoleById, getRoleDetails, getRolesDictionary, getRolesListWithPaginationFilterAndSorting} from "../../../redux/api/apiRoles";
import {setCurrentPage, setCurrentPageSize, setRoleArchiveTableToggle, setRoleDialogVisible, setRoleErrorFields, setRoleListDataSort, setRolesClearFilters, setRolesUiFilters, setSelectedRolesIndex} from "../../../redux/actions/actionsRoles";
import {
    areSearchParamsEqual,
    buildRolesSearchParams,
    readInitialRolesUrlState
} from "../../../utils/rolesUrlState";
import RolesListDetails from "./RolesListDetails";
import RolesListDialog from "./RolesListDialog";
import {Paginator} from "primereact/paginator";
import {Dropdown} from "primereact/dropdown";
import {getNotificationMessage} from "../../../redux/api/apiNotifications";
import {setEditType} from "../../../redux/actions/actions";
import BranchDialog from "../../Branch/BranchDialog";

const RolesList = () => {
    const dispatch = useAppDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const [initialRolesUrlState] = useState(readInitialRolesUrlState);
    const clearFilters = useAppSelector(state => state.RolesReducer.clearFilters);
    const companies = useAppSelector(state => state.CompaniesListReducer);
    const pagination = useAppSelector(state => state.RolesReducer.pagination);
    const paginationPage = useAppSelector(state => state.RolesReducer.paginationPage);
    const paginationSize = useAppSelector(state => state.RolesReducer.paginationSize);
    const archiveRolesTableToggle = useAppSelector(state => state.RolesReducer.archiveRolesTableToggle);
    const loader = useAppSelector(state => state.RolesReducer.loading);
    const [visible, setVisible] = useState<boolean>(false);
    const [mobileVisible, setMobileVisible] = useState<boolean>(false);
    // const [cancelNotificationStatusChange, setCancelNotificationStatusChange] = useState<boolean>(false);
    const [showCopyNotification, setShowCopyNotification] = useState<boolean>(false);
    const [id, setId] = useState<number>(0);
    const toast = useRef<Toast>(null);
    const [first, setFirst] = useState(() => (initialRolesUrlState.page - 1) * initialRolesUrlState.size);
    const [data] = useState<any>(null);
    const [orderBy, setOrderBy] = useState<any>(initialRolesUrlState.orderBy);
    const [isDescFilter, setIsDescFilter] = useState<boolean>(initialRolesUrlState.isDesc);
    const [filterRoleId, setFilterRoleId] = useState<any>(initialRolesUrlState.filterRoleId);
    const [filterRoleName, setFilterRoleName] = useState<any>(initialRolesUrlState.filterRoleName);
    const [filterStatusId, setFilterStatusId] = useState<any>(initialRolesUrlState.filterStatusId)
    const [sortOrder, setSortOrder] = useState<number>(initialRolesUrlState.sortOrder);
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as unknown as Record<string, string[]>;
    const rolePermissions = checkPermissions(rolesVision, 'Role');
    const [page, setPage] = useState<any>(initialRolesUrlState.page);
    const hasInitializedPagination = useRef(false);
    const skipUrlWriteRef = useRef(true);
    const skipArchivePageResetRef = useRef(true);
    const waitingArchiveHydrationRef = useRef(!initialRolesUrlState.archiveTableToggle);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [selectedRowData, setSelectedRowData] = useState<any | null>(null);
    const rolesList = useAppSelector(state => state.RolesReducer.rolesList) as unknown as any;
    const rolesData = useAppSelector(state => state.RolesReducer.rolesData) as unknown as any;
    const notifications = useAppSelector(state => state.NotificationsReducer);
    const dataSort = useAppSelector(state => state.RolesReducer.dataSort);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const user = useAppSelector(state => state.UsersReducer.userData);
    const [showUnArchiveNotification, setShowUnArchiveNotification] = useState<boolean>(false);
    const progressBar = <ProgressBar mode="indeterminate" style={{height: '2px', maxWidth: '95%'}}></ProgressBar>;
    const [sortData, setSortData] = useState<any>({
        isArchived: !archiveRolesTableToggle,
        pageNumber: page ? page : paginationPage,
        pageSize: paginationSize,
        sort: {
            orderBy: orderBy ? orderBy : "Id",
            isDesc: isDescFilter
        }
    });
    // @ts-ignore
    const activeClick = useAppSelector(state => state.UsersListReducer.activeClick);
    const {
        create: hasRoleCreatePermission,
        update: hasRoleUpdatePermission,
        delete: hasRoleDeletePermission,
    } = rolePermissions;

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (initialRolesUrlState.hasAny) {
            if (Object.keys(initialRolesUrlState.uiFilters || {}).length > 0) {
                dispatch(setRolesUiFilters(initialRolesUrlState.uiFilters));
            } else {
                dispatch(setRolesClearFilters());
            }
            if (initialRolesUrlState.page !== 1) {
                dispatch(setCurrentPage(initialRolesUrlState.page));
            }
            if (initialRolesUrlState.size !== 10) {
                dispatch(setCurrentPageSize(initialRolesUrlState.size));
            }
            if (!initialRolesUrlState.archiveTableToggle) {
                dispatch(setRoleArchiveTableToggle(false));
            }
            dispatch(getRolesDictionary(jwtToken?.jwtToken));
            return;
        }

        dispatch(setRolesClearFilters());
        dispatch(setCurrentPage(1));
        dispatch(setCurrentPageSize(10));
        dispatch(setRoleArchiveTableToggle(true));
        dispatch(getRolesDictionary(jwtToken?.jwtToken));
    }, []);

    useEffect(() => {
        if (!user?.userId) {
            return;
        }
        if (!getItem(codes.archive_role_question)) {
            dispatch(getNotificationMessage(user.userId, 144, user));
        }
        if (!getItem(codes.copy_role)) {
            dispatch(getNotificationMessage(user.userId, 200, user));
        }
    }, [user?.userId, dispatch]);

    const resetTableHorizontalScroll = () => {
        const scrollableBody = document.querySelector('.p-datatable-wrapper');
        if (scrollableBody) {
            scrollableBody.scrollTop = 0; // Сброс прокрутки
            scrollableBody.scrollLeft = 0;
        }
    };

    useEffect(() => {
        if (!hasInitializedPagination.current) {
            hasInitializedPagination.current = true;
            const urlPage = initialRolesUrlState.page || 1;
            const urlSize = initialRolesUrlState.size || 10;
            const pageChanged = paginationPage !== urlPage;
            const sizeChanged = paginationSize !== urlSize;
            if (pageChanged) {
                dispatch(setCurrentPage(urlPage));
            }
            if (sizeChanged) {
                dispatch(setCurrentPageSize(urlSize));
            }
            if (pageChanged || sizeChanged) {
                return;
            }
        }
        if (!jwtToken?.jwtToken) {
            return;
        }
        if (waitingArchiveHydrationRef.current) {
            if (archiveRolesTableToggle !== initialRolesUrlState.archiveTableToggle) {
                return;
            }
            waitingArchiveHydrationRef.current = false;
        }
        setSelectedRowData(null);
        let filter: { key: string; value: string }[] = [];
        const dataSort: RoleDataSort = {
            isArchived: !archiveRolesTableToggle,
            pageNumber: page ? page : paginationPage,
            pageSize: paginationSize,
            sort: {
                orderBy: orderBy ? orderBy : "Id",
                isDesc: isDescFilter
            }
        }

        if (filterRoleId?.value) {
            filter.push(filterRoleId);
        }
        if (filterRoleName?.value) {
            filter.push(filterRoleName);
        }
        if (filterStatusId) {
            dataSort.active = filterStatusId?.value
        }
        if (filter) {
            dataSort['filter'] = filter;
        }
        dispatch(getRolesListWithPaginationFilterAndSorting(dataSort, jwtToken?.jwtToken));
        dispatch(setRoleListDataSort(dataSort));
        setPage(null);
        setSortData(dataSort);
        resetTableHorizontalScroll();
    }, [paginationPage, paginationSize, data, archiveRolesTableToggle, orderBy, isDescFilter, filterRoleId, filterRoleName, filterStatusId, jwtToken?.jwtToken]);

    useEffect(() => {
        if (skipUrlWriteRef.current) {
            skipUrlWriteRef.current = false;
            return;
        }

        const nextParams = buildRolesSearchParams({
            page: paginationPage,
            size: paginationSize,
            orderBy,
            isDesc: isDescFilter,
            sortOrder,
            archiveTableToggle: archiveRolesTableToggle,
            filterRoleId,
            filterRoleName,
            filterStatusId,
        });

        if (!areSearchParamsEqual(searchParams, nextParams)) {
            setSearchParams(nextParams, {replace: true});
        }
    }, [
        paginationPage, paginationSize, orderBy, isDescFilter, sortOrder, archiveRolesTableToggle,
        filterRoleId, filterRoleName, filterStatusId, searchParams, setSearchParams
    ]);

    useEffect(() => {
        if (activeClick?.item === "/role" && activeClick?.from ==='#/role') {
            dispatch(getRolesListWithPaginationFilterAndSorting(sortData, jwtToken?.jwtToken));
            resetTableHorizontalScroll();
        }
    }, [activeClick]);

    let archiveRoleNotification = getItem(codes.archive_role_question);
    let copyNotification = getItem(codes.copy_role);

    // const cancelMessage = <div>{companies && companies.notificationCancel ? companies.notificationCancel.text : cancelNotification ? cancelNotification : progressBar}</div>
    // @ts-ignore
    const copyRoleMessage = <div>{notifications && notifications.copyRoleMessage ? notifications.copyRoleMessage.text : copyNotification ? copyNotification : progressBar}</div>
    const archivedRoleNotificationMessage = <div>{notifications?.archiveRoleMessage?.text ? notifications.archiveRoleMessage.text : archiveRoleNotification ? archiveRoleNotification : progressBar}</div>


    useEffect(() => {
        if (skipArchivePageResetRef.current) {
            skipArchivePageResetRef.current = false;
            return;
        }
        if (waitingArchiveHydrationRef.current) {
            return;
        }
        setFirst(0);
        dispatch(setCurrentPageSize(10));
        dispatch(setCurrentPage(1));
    }, [archiveRolesTableToggle]);


    const copyRoleMethod = () => {
        if (jwtToken?.jwtToken) {
            dispatch(copyRoleById(id, jwtToken?.jwtToken, dataSort));
        }
    }

    const archiveRoleAction = () => {
        if (jwtToken?.jwtToken) {
            dispatch(archiveRole(id, jwtToken?.jwtToken, dataSort));
        }
    }

    const deletionToastShow = (roleId: number) => {
        if (!archiveRoleNotification && !notifications?.archiveRoleMessage && user?.userId) {
            dispatch(getNotificationMessage(user.userId, 144, user));
        }
        setVisible(true);
        setId(roleId);
    };

    const copyToastShow = (roleId: number) => {
        if (!copyNotification && !notifications?.copyRoleMessage && user?.userId) {
            dispatch(getNotificationMessage(user.userId, 200, user));
        }
        setShowCopyNotification(true);
        setId(roleId);
    };

    const unArchiveToastShow = (roleId: number) => {
        setShowUnArchiveNotification(true);
        setId(roleId);
    };

    const actionTemplate = (rowData: any) => {
        return (
            <div className="flex">
                <div className="controls-buttons">
                    {hasRoleCreatePermission && (<Button className="p-button-text p-button-icon" onClick={() => copyToastShow(rowData.id)} icon="pi pi-copy"></Button>)}
                </div>
                {archiveRolesTableToggle && hasRoleDeletePermission && <Button className="p-button-text" icon="pi pi-trash" disabled={!rowData.isEdit} onClick={() => deletionToastShow(rowData.id)}></Button>}
                {!archiveRolesTableToggle && hasRoleCreatePermission && <Button className="p-button-text" icon="pi pi-folder-open" onClick={() => unArchiveToastShow(rowData.id)}></Button>}
            </div>
        );
    };

    const filterClearTemplate = (options: any) => {
        return <Button type="button" icon="pi pi-times" onClick={options.filterClearCallback} className="p-button-secondary"></Button>;
    }

    const filterApplyTemplate = (options: any) => {
        return <Button type="button" icon="pi pi-check" onClick={options.filterApplyCallback} className=""></Button>
    }

    const dataTableRef = useRef<any>(null);

    const handleReset = () => {
        dataTableRef?.current?.reset();
        customFilter();
        setSortOrder(0);
        dispatch(setRolesClearFilters());
        dispatch(setCurrentPageSize(10));
        dispatch(setCurrentPage(1));
        setFirst(0);
        skipUrlWriteRef.current = true;
        setSearchParams(new URLSearchParams(), {replace: true});
    };

    const onPageChange = (event: any) => {
        setFirst(event.first);
        dispatch(setCurrentPage(event.page + 1));
        dispatch(setCurrentPageSize(event.rows));
        setSortData((prev: any) => ({...prev, pageNumber: event.page + 1, pageSize: event.rows}));
    };

    const customSort = (event: any) => {
        const handleAction = (sortField: string) => {
            let newOrderBy: string;

            switch (sortField) {
                case 'id':
                    newOrderBy = 'Id';
                    break;
                case 'name':
                    newOrderBy = 'Name';
                    break;
                case 'active':
                    newOrderBy = 'Active';
                    break;
                default:
                    return;
            }

            setOrderBy(newOrderBy);
            setIsDescFilter(!isDescFilter);
            setSortOrder(sortOrder === 1 ? -1 : 1);
        };
        let sortField = event.sortField;
        handleAction(sortField);
    };


    const customFilter = (event?: any) => {
        if (event) {
            const {id, name, active} = event.filters;
            setFilterRoleId(id ? {key: 'Id', value: id.constraints[0].value} : null);
            setFilterRoleName(name ? {key: 'Name', value: name.constraints[0].value} : null);
            setFilterStatusId(active ? {key: 'Active', value: active.value?.code ?? active.value ?? null} : null);
        } else {
            setFilterRoleId(null);
            setFilterRoleName(null);
            setFilterStatusId(null);
            setOrderBy(null);
            setIsDescFilter(true);
        }
    };

    const renderHeader = (field: string, sortField: string) => {
        const sorted = sortField === orderBy;
        const sortIcon = classNames('p-sortable-column-icon', {
            'pi pi-sort-amount-up-alt': sorted && sortOrder === 1,
            'pi pi-fw pi-sort-amount-down': sorted && sortOrder === -1,
            'pi pi-fw pi-sort-alt': sortOrder === 0 || !sorted
        });

        return (
            <div className="flex align-items-center sticky top-0" onClick={() => customSort({'sortField': sortField})}>
                {field} <i className={sortIcon}></i>
            </div>
        );
    };

    const isMobile = () => {
        return windowWidth <= 1248;
    }

    const openEditCampaignDialog = () => {
        dispatch(setSelectedRolesIndex(rolesData?.id || selectedRowData));
        dispatch(setRoleDialogVisible(true));
        setSelectedRowData(null);
        if (hasRoleUpdatePermission) {
            dispatch(setEditType(true));
        } else {
            dispatch(setEditType(false));
        }
    }

    const dialogHeader = () => {
        return <>
            <div className="flex align-items-center justify-content-end m-0 p-0 mr-1">
                <Button className="p-dialog-header-icon p-dialog-header-close p-link border-noround	outline-none shadow-none h-full justify-content-end" onClick={() => {
                    openEditCampaignDialog();
                }}>
                    <span className={classNames('', {
                        'pi pi-pencil': archiveRolesTableToggle && hasRoleUpdatePermission && rolesData?.isEdit,
                        'pi pi-eye': !archiveRolesTableToggle || !hasRoleUpdatePermission || !rolesData?.isEdit
                    })}></span></Button>
            </div>
        </>
    }

    const activeDict = [
        {name: 'Активна', code: true},
        {name: 'Неактивна', code: false},
    ];

    const activeFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Виберіть:</div>
                <Dropdown
                    value={options.value}
                    options={activeDict}
                    // itemTemplate={activeItemTemplate}
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    optionLabel="name"
                    className="p-column-filter"
                />
            </>
        );
    };

    return (
        <div className="layout-dashboard">
            <Toast ref={toast}/>
            <div className="">
                <div className="flex flex-wrap col-12 md:col-12 p-0">
                    {/*<div className="card widget-table">*/}
                    <div className={classNames('card widget-table col-12 transition-duration-300 monitoring-table align-self-start m-0 mr-0', {'': selectedRowData && !isMobile(), 'md:col-12': !selectedRowData})}>
                        <RolesListNav handleReset={handleReset}/>
                        <DataTable
                            ref={dataTableRef}
                            scrollable
                            scrollHeight={(selectedRowData) && !isMobile() ? '35vh' : '70vh'}
                            className="p-datatable-customers"
                            value={archiveRolesTableToggle ? rolesList : rolesList}
                            dataKey="id"
                            lazy
                            filters={clearFilters}
                            rowHover={false}
                            selectionMode="single"
                            selection={selectedRowData}
                            onSort={customSort}
                            onFilter={customFilter}
                            emptyMessage="Нічого не знайдено"
                            responsiveLayout='scroll'
                            onRowClick={(e) => {
                                setSelectedRowData(e.data.id);
                                dispatch(getRoleDetails(e.data.id, jwtToken?.jwtToken));
                                dispatch(setSelectedRolesIndex(e.data.id));
                                dispatch(setRoleErrorFields(null));
                                setMobileVisible(true);
                                if (isMobile()) {
                                    setMobileVisible(true);
                                }
                            }}
                            loading={loader}
                            rowClassName={(rowData: any) =>
                                rowData?.id === selectedRowData ? 'p-highlight' : ''
                            }
                        >
                            <Column
                                field="id"
                                filterField="id"
                                header={renderHeader('ID', 'Id')}
                                showFilterMatchModes={false}
                                showFilterMenuOptions={false}
                                filterPlaceholder="Введіть ID:"
                                filter
                                sortable
                                className={classNames('', {'active-header-column': orderBy === 'CampaignId'})}
                                filterClear={filterClearTemplate}
                                filterApply={filterApplyTemplate}
                                style={{cursor: 'pointer', width: '10%', minWidth: '90px'}}
                            />
                            <Column
                                field="name"
                                filterField="name"
                                header={renderHeader('Назва', 'Name')}
                                className={classNames('', {'active-header-column': orderBy === 'Name'})}
                                showFilterMatchModes={false}
                                showFilterMenuOptions={false}
                                filterPlaceholder="Введіть назву кампанії"
                                filter
                                sortable
                                filterClear={filterClearTemplate}
                                filterApply={filterApplyTemplate}
                                style={{cursor: 'pointer', width: (hasRoleCreatePermission || hasRoleDeletePermission) ? '50%' : '70%', minWidth: '150px'}}
                            />
                            <Column
                                field="active"
                                filterField="active"
                                header={renderHeader('Стан', 'Active')}
                                className={classNames('', {'active-header-column': orderBy === 'Active'})}
                                showFilterMatchModes={false}
                                showFilterMenuOptions={false}
                                filterPlaceholder="Введіть назву кампанії"
                                filter
                                body={data => data?.active ? 'Активна' : 'Не активна'}
                                sortable
                                filterClear={filterClearTemplate}
                                filterApply={filterApplyTemplate}
                                filterElement={activeFilterTemplate}
                                style={{cursor: 'pointer', width: '20%', minWidth: '150px'}}
                            />
                            {(hasRoleCreatePermission || hasRoleDeletePermission) && (<Column header="Дія" style={{cursor: 'pointer', width: '20%', minWidth: '100px'}} body={actionTemplate}></Column>)}
                        </DataTable>
                        <Paginator
                            first={first}
                            rows={paginationSize}
                            totalRecords={pagination.totalItems}
                            rowsPerPageOptions={[5, 10, 15, 25, 50]}
                            onPageChange={onPageChange}
                            className="border-top-1 border-bottom-1"
                        />
                    </div>
                    {selectedRowData && companies && (
                        <>
                            {windowWidth > 1248 && <div className={classNames('card widget-table col-12 md:col-12 align-self-start sticky top-0 mt-4')}>
                                <RolesListDetails setSelectedRowData={setSelectedRowData} selectedRowData={selectedRowData} windowWidth={windowWidth}/>
                            </div>}

                            {windowWidth <= 1248 && <div>
                                <Dialog visible={mobileVisible} header={dialogHeader} className="monitoring-info" onHide={() => setMobileVisible(false)}>
                                    <RolesListDetails/>
                                </Dialog>
                            </div>}
                        </>
                    )}
                    <RolesListDialog/>
                    <ConfirmDialog visible={showUnArchiveNotification} onHide={() => setShowUnArchiveNotification(false)} message={'Роль буде розпаковано ! Розпакувати роль ?'}
                                   icon="pi pi-exclamation-triangle" acceptLabel="Продовжити" rejectLabel="Відмінити" accept={() => {
                        archiveRoleAction()
                        if (id === selectedRowData) {
                            setSelectedRowData(null);
                        }
                    }}/>
                    <ConfirmDialog visible={showCopyNotification} onHide={() => setShowCopyNotification(false)} message={copyRoleMessage}
                                   icon="pi pi-exclamation-triangle" acceptLabel="Продовжити" rejectLabel="Відмінити" accept={() => copyRoleMethod()}/>
                    <ConfirmDialog visible={visible} onHide={() => setVisible(false)} message={archivedRoleNotificationMessage}
                                   icon="pi pi-exclamation-triangle" acceptLabel="Продовжити" rejectLabel="Відмінити" accept={() => {
                        archiveRoleAction()
                        if (id === selectedRowData) {
                            setSelectedRowData(null);
                        }
                    }}/>
                </div>
            </div>
            <BranchDialog/>
        </div>
    );
};

export default RolesList;
